import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 9px 24px;
  background-color: ${({ theme }) => theme.colors.white};
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey003};
`;

export const SubHeaderTitle = styled(typography.TitleOneBoldTypography)``;

export const SubHeaderTotalCount = styled.div`
  display: flex;
  align-items: center;
  height: 24px;
  margin-left: 8px;
  padding: 1px 8px;
  border-radius: 53px;
  background-color: ${({ theme }) => theme.colors.grey100};
`;

export const AddBtn = styled(typography.BodyTextOneRegularTypography)`
  margin-inline-start: auto;
  padding: 8px 16px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.blueMain};
  border: 0px;
  border-radius: 4px;
  cursor: pointer;
  cursor: pointer;
  &:before {
    content: '\\e910';
    font-family: 'Icomoon';
    font-size: 12px;
    margin-inline-end: 8px;
  }
`;
